import React from "react"
import { Grid, Typography, Button } from "@mui/material"
import { EmailButtonStyles } from "./styles/UserNotFoundStyles"

function UserNotFound() {

    const handleContactGDS = () => {
        const mailto = "servicedesk@precipart.com"
        const subject = `New Application User Setup`
        const body = `Request for user setup sent from Request Account Setup feature.`
        window.open(`mailto:${mailto}?subject=${subject}&body=${body}`)
    }

    return (
        <Grid container justify="center">
            <Grid item align="center" size={10}>
                <Typography variant="h5">
                    Please contact the Global Digital Solutions team for help
                    setting up your account
                </Typography>
            </Grid>
            <Grid item align="center" size={10} sx={EmailButtonStyles}>
                <Button variant="outlined" onClick={handleContactGDS}>
                    Send An Email
                </Button>
            </Grid>
        </Grid>
    )
}

export default UserNotFound
